module.exports = __webpack_public_path__ + "static/img/icon-coupon-discount.aef63ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-coupon-discount.png
// module id = 112
// module chunks = 7